import React from 'react';
import { Sun, ShieldCheck, AlertCircle } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { useTheme } from '../../context/ThemeContext';

export const LoginPage: React.FC = () => {
  const { login, demoLogin, error, loading } = useAuth();
  const { isDark, toggleTheme } = useTheme();

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        padding: '20px',
      }}
    >
      {/* Theme switch in top corner */}
      <div style={{ position: 'absolute', top: '24px', right: '32px' }}>
        <button
          className="theme-switch"
          type="button"
          role="switch"
          aria-checked={isDark}
          onClick={toggleTheme}
        >
          <div className="theme-switch-thumb" />
        </button>
      </div>

      {/* Login Card */}
      <div
        style={{
          width: '100%',
          maxWidth: '440px',
          background: 'var(--surface)',
          border: '1px solid var(--surface-border)',
          borderRadius: '24px',
          padding: '40px',
          boxShadow: 'var(--shadow-glass)',
          backdropFilter: 'blur(16px)',
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '20px',
        }}
      >
        <div
          style={{
            width: '64px',
            height: '64px',
            background: 'rgba(245, 127, 23, 0.1)',
            borderRadius: '16px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'var(--primary)',
          }}
        >
          <Sun className="h-10 w-10" />
        </div>

        <div>
          <h1 style={{ fontSize: '1.8rem', margin: '0 0 8px 0', fontWeight: 700 }}>
            Helios One
          </h1>
          <p style={{ margin: 0, color: 'var(--text-muted)', fontSize: '0.95rem' }}>
            Plan Extraction &amp; Electrical Takeoff Tool
          </p>
        </div>

        {error && (
          <div
            style={{
              width: '100%',
              padding: '12px',
              borderRadius: '10px',
              background: 'rgba(239, 68, 68, 0.15)',
              border: '1px solid rgba(239, 68, 68, 0.3)',
              color: '#ef4444',
              fontSize: '0.85rem',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              textAlign: 'left',
            }}
          >
            <AlertCircle className="h-4 w-4 flex-shrink-0" />
            <span>{error}</span>
          </div>
        )}

        <button
          type="button"
          className="btn-primary"
          style={{
            width: '100%',
            padding: '14px 20px',
            borderRadius: '30px',
            fontSize: '1rem',
            fontWeight: 700,
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '10px',
            transition: 'var(--transition)',
          }}
          disabled={loading}
          onClick={login}
        >
          <ShieldCheck className="h-5 w-5" />
          <span>{loading ? 'Checking session...' : 'Sign in with Big Sun Connect'}</span>
        </button>

        <button
          type="button"
          className="tool-btn"
          style={{
            width: '100%',
            padding: '10px 16px',
            fontSize: '0.9rem',
            fontWeight: 600,
            justifyContent: 'center',
            color: 'var(--primary)',
            borderColor: 'var(--primary)',
          }}
          onClick={demoLogin}
        >
          <span>Demo &amp; Testing Mode (Instant Access)</span>
        </button>

        <p style={{ margin: 0, fontSize: '0.8rem', color: 'var(--text-muted)' }}>
          Secure authentication managed through Big Sun Connect SSO.
        </p>
      </div>
    </div>
  );
};
